//import 'dotenv/config';

const envConfig = process.env;

if(!envConfig.REACT_APP_NODE_ENV){
    console.log("Error No Environmental Settings");
}

export default envConfig;
